module.exports = __webpack_public_path__ + "fonts/Inter-600-latin63.8e433c0.woff2";